import React from 'react';

export const EditResultContext = React.createContext(null);